/**
 * 路径相关的工具函数
 */

import path from 'path';
import fs from 'fs-extra';

/**
 * 获取工作流根目录
 */
export function getWorkflowRoot(): string {
  // 如果环境变量中指定了根目录，使用它
  if (process.env.WORKFLOW_ROOT) {
    return process.env.WORKFLOW_ROOT;
  }
  
  // 否则使用当前工作目录
  return process.cwd();
}

/**
 * 获取 .workflow 目录路径
 */
export function getWorkflowDir(): string {
  return path.join(getWorkflowRoot(), '.workflow');
}

/**
 * 获取 .claude 目录路径
 */
export function getClaudeDir(): string {
  return path.join(getWorkflowRoot(), '.claude');
}

/**
 * 确保目录存在
 */
export async function ensureDir(dirPath: string): Promise<void> {
  await fs.ensureDir(dirPath);
}

/**
 * 检查文件是否存在
 */
export async function pathExists(filePath: string): Promise<boolean> {
  return fs.pathExists(filePath);
}

/**
 * 获取相对路径（相对于工作流根目录）
 */
export function getRelativePath(filePath: string): string {
  return path.relative(getWorkflowRoot(), filePath);
}

/**
 * 获取绝对路径
 */
export function getAbsolutePath(filePath: string): string {
  if (path.isAbsolute(filePath)) {
    return filePath;
  }
  return path.join(getWorkflowRoot(), filePath);
}